import { Component, Input } from "@angular/core";
import { PropostaService } from "administrativo-lib";
import { AssinaturaService, BaseResourceRptPersonalizadoComponent, CpfPipe, Licitacao, LicitacaoPipe, Proposta } from "eddydata-lib";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-termo-homologacao-rpt',
  templateUrl: './termo-homologacao-rpt.component.html'
})
export class TermoHomologacaoRptComponent extends BaseResourceRptPersonalizadoComponent {

  @Input() public licitacao: Licitacao;

  constructor(
    private propostaService: PropostaService,
    protected assinaturaService: AssinaturaService,
  ) {
    super(assinaturaService);
    this.assinaturaObrigatoria = true;
  }

  protected afterInit(): void {
  }

  protected modalRelatorio(): string {
    return 'dialogRelatorioTermoHomologacao';
  }

  protected tituloRelatorio(): string {
    return 'Termo de Homologação';
  }

  protected layoutRelatorio(): {} {
    return {
      table_eddy: {
        hLineWidth: function (i, node) {
          return i === node.table.body.length || i === 0 ? 0 : 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return i === node.table.headerRows || i === node.table.body.length - 1 ? 'black' : '#eee';
        },
        paddingLeft: function (i) {
          return i === 0 ? 0 : 8;
        },
        paddingRight: function (i, node) {
          return (i === node.table.widths.length - 1) ? 0 : 8;
        },
        fillColor: function (i, node) {
          if (i === 0 || i === node.table.headerRows || i === node.table.body.length - 1) {
            return null;
          }
          return (i % 2 === 0) ? '#f5f5f5' : null;
        }
      }
    }
  }

  protected async montarConteudo(): Promise<{}[]> {
    const conteudo = [];
    return await new Promise(async (resolve) => {
      conteudo.push(this.dadosCabecalho())
      conteudo.push(await this.dadosVencedores());
      conteudo.push(await this.dadosFracassados())
      conteudo.push(this.dadosRodape())

      resolve(conteudo);
    })
  }

  private dadosCabecalho(): {}[] {
    let texto = `Consoante ata de fls. Precedentes, a pregoeira designada pela Portaria ${this.licitacao.comissao.portaria}`;
    if (this.licitacao.comissao.publicacao) {
      texto += ` de ${this.licitacao.comissao.publicacao}`;
    }
    texto += `, comunicou sem quaisquer óbices, a ADJUDICAÇÃO do objeto do ${this.licitacao.modalidade.nome} nº ${new LicitacaoPipe().transform(this.licitacao.numero)} cujo objeto refere-se ao ${this.licitacao.objeto}, foram adjudicados:`;

    const conteudo = [
      { text: 'TERMO DE HOMOLOGAÇÃO', alignment: 'center', bold: true, fontSize: 16, decoration: 'underline', margin: [0, 0, 0, 10] },
      {
        text: texto, fontSize: 10, alignment: 'justify', margin: [0, 0, 0, 10]
      },
    ]
    return conteudo;
  }

  private async dadosVencedores(): Promise<{}[]> {
    const vencedores: {
      favorecido: string,
      item: string,
      quantidade: number,
      valor_unit: number,
      total: number,
    }[] = []

    return await new Promise((resolve) => {
      this.propostaService.obterVencedores(this.licitacao.id, 'proponente.favorecido.nome,memorial.ordem').pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          const reg: Proposta[] = res.content;

          reg.forEach(p => {
            vencedores.push({
              favorecido: `${new CpfPipe().transform(p.proponente.favorecido.cpf_cnpj)} - ${p.proponente.favorecido.nome}`,
              item: `${p.memorial.ordem} - ${p.memorial.descricao} ${p.memorial.unidade}`,
              quantidade: +p.quantidade_final,
              valor_unit: +p.valor_final,
              total: +Number(+p.quantidade_final * +p.valor_final).toFixed(4)
            })
          });

          const itensAgrupados = this.funcaoService.agrupar(vencedores, 'favorecido', ['quantidade', 'valor_unit', 'total']);

          const tabelas = [];
          itensAgrupados.forEach(grupo => {
            const conteudo = [];
            conteudo.push(
              [
                { text: `${grupo.grupo}`, fontSize: 11, bold: true, colSpan: 4, alignment: 'left', margin: [0, 10, 0, 5] }, {}, {}, {}
              ],
              [
                { text: 'ITEM', alignment: 'center', fontSize: 10, bold: true },
                { text: 'QTDE.', alignment: 'center', fontSize: 10, bold: true },
                { text: 'VALOR UNIT.', alignment: 'center', fontSize: 10, bold: true },
                { text: 'VALOR TOTAL', alignment: 'center', fontSize: 10, bold: true },
              ],
            )

            grupo.registros.forEach(item => {
              conteudo.push(
                [
                  { text: `${item['item']}`, alignment: 'left', fontSize: 9 },
                  { text: `${this.funcaoService.convertToBrNumber(item['quantidade'], 0)}`, alignment: 'right', fontSize: 9 },
                  { text: `${this.funcaoService.convertToBrNumber(item['valor_unit'], 4)}`, alignment: 'right', fontSize: 9 },
                  { text: `${this.funcaoService.convertToBrNumber(item['total'], 4)}`, alignment: 'right', fontSize: 9 },
                ],
              )
            })
            conteudo.push(
              [
                { text: 'Total', fontSize: 9, bold: true, alignment: 'left', margin: [0, 5, 0, 5] },
                { text: `${this.funcaoService.convertToBrNumber(grupo.totalizadores['quantidade'], 0)}`, fontSize: 9, bold: true, alignment: 'right', margin: [0, 5, 0, 5] },
                { text: `${this.funcaoService.convertToBrNumber(grupo.totalizadores['valor_unit'], 4)}`, fontSize: 9, bold: true, alignment: 'right', margin: [0, 5, 0, 5] },
                { text: `${this.funcaoService.convertToBrNumber(grupo.totalizadores['total'], 4)}`, fontSize: 9, bold: true, alignment: 'right', margin: [0, 5, 0, 5] },
              ],
            )
            tabelas.push(conteudo)
          })

          const content = []
          content.push({ text: 'VENCEDORES', alignment: 'center', bold: true, fontSize: 12, margin: [0, 10, 0, 0] })
          tabelas.forEach(t => {
            content.push(
              {
                layout: 'table_eddy',
                table: {
                  dontBreakRows: true,
                  headerRows: 1,
                  widths: ['*', 30, 60, 75],
                  body: t
                }
              }
            )
          })
          resolve(content)
        });
    })
  }

  private async dadosFracassados(): Promise<{}[]> {
    return await new Promise((resolve) => {
      this.propostaService.filtrar(0, 0, {
        'memorial.licitacao_id': this.licitacao.id,
        'situacao': 'FRACASSADO',
        'orderBy': 'memorial.ordem'
      }
      ).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          const reg: Proposta[] = res.content;

          const itens = reg.map(p => p.memorial).filter((item, idx, self) => idx === self.findIndex((itm) => itm.id === item.id));

          const conteudo = [];
          conteudo.push(
            [
              { text: 'ITEM', alignment: 'center', fontSize: 10, bold: true },
              { text: 'QTDE.', alignment: 'center', fontSize: 10, bold: true },
            ],
          )

          itens.forEach(item => {
            conteudo.push(
              [
                { text: `${item.ordem} - ${item.descricao} ${item.unidade}`, alignment: 'left', fontSize: 9 },
                { text: `${this.funcaoService.convertToBrNumber(item.quantidade, 0)}`, alignment: 'right', fontSize: 9 },
              ],
            )
          })

          const content = []
          content.push({ text: 'FRACASSADOS', alignment: 'center', bold: true, fontSize: 12, margin: [0, 10, 0, 5] })
          content.push(
            {
              layout: 'table_eddy',
              table: {
                dontBreakRows: true,
                headerRows: 1,
                widths: ['*', 'auto'],
                body: conteudo
              }
            }
          )

          resolve(content)
        });
    })
  }

  private dadosRodape(): {}[] {
    const assinaturas = this.assinatura.pessoas.filter(p => p.selecionado);
    if (assinaturas?.length === 0) return [{}];

    let texto: string = (assinaturas.length > 1 ? 'Nós' : 'Eu') + ', ';
    assinaturas.forEach(a => {
      texto += `${a.pessoa.nome} - ${a.cargo}, `;
    });
    texto += (assinaturas.length > 1 ? 'homologamos' : 'homologo');

    const conteudo: {}[] = [
      {
        text: `${texto} o objeto a mesma empresa, pelo valor retro, nos termos da legislação de regência de matéria.`,
        fontSize: 10, alignment: 'justify', margin: [0, 20, 0, 10]
      },
      {
        text: 'Prossiga o feito com formalização de ata de registro de preços, respectiva publicação sintética, e demais providências administrativas.',
        fontSize: 10, alignment: 'justify', margin: [0, 0, 0, 10]
      },
      { text: this.funcaoService.formatarDataExtenso(new Date(), this.login.cidade.nome), alignment: 'center', fontSize: 10, margin: [0, 30, 0, 70] },
    ]

    return conteudo.concat(this.imprimirAssinaturas(assinaturas));
  }

}